import { AppCacheStatus } from '@fullstory/redux-util/utils';
import { WithID } from '@fullstory/util/uid';
import { RetentionMetricDetail } from '@fullstory/proto/fs/services/dx-objects';
import {
  ComputeRetentionMetricsRequest,
  ComputeRetentionMetricsResponse,
  QueryCacheOptions,
} from '@fullstory/proto/fs/services/alexa';
import { Retention, RetentionResult } from '@fullstory/proto/fs/api/metrics/retention';

export enum RetentionMetricsRequestTypes {
  GetAllRetentionMetricsRequest = 'retention/GET_ALL_RETENTION_METRICS_REQUEST',
  GetAllRetentionMetricsSuccess = 'retention/GET_ALL_RETENTION_METRICS_SUCCESS',
  GetAllRetentionMetricsFailure = 'retention/GET_ALL_RETENTION_METRICS_FAILURE',
  SetRetentionMetricRequest = 'retention/SET_RETENTION_METRIC_REQUEST',
  SetRetentionMetricSuccess = 'retention/SET_RETENTION_METRIC_SUCCESS',
  SetRetentionMetricFailure = 'retention/SET_RETENTION_METRIC_FAILURE',
  MarkViewedRequest = 'retention/MARK_VIEWED_REQUEST',
  MarkViewedSuccess = 'retention/MARK_VIEWED_SUCCESS',
  MarkViewedFailure = 'retention/MARK_VIEWED_FAILURE',
  StarRetentionMetricRequest = 'retention/STAR_RETENTION_METRIC_REQUEST',
  StarRetentionMetricSuccess = 'retention/STAR_RETENTION_METRIC_SUCCESS',
  StarRetentionMetricFailure = 'retention/STAR_RETENTION_METRIC_FAILURE',
  ArchiveRetentionMetricRequest = 'retention/ARCHIVE_RETENTION_METRIC_REQUEST',
  ArchiveRetentionMetricSuccess = 'retention/ARCHIVE_RETENTION_METRIC_SUCCESS',
  ArchiveRetentionMetricFailure = 'retention/ARCHIVE_RETENTION_METRIC_FAILURE',
  CreateUnnamedRetentionMetricRequest = 'retention/CREATE_UNNAMED_RETENTION_METRIC_REQUEST',
  CreateUnnamedRetentionMetricSuccess = 'retention/CREATE_UNNAMED_RETENTION_METRIC_SUCCESS',
  CreateUnnamedRetentionMetricFailure = 'retention/CREATE_UNNAMED_RETENTION_METRIC_FAILURE',
  GetUnnamedRetentionMetricRequest = 'retention/GET_UNNAMED_RETENTION_METRIC_REQUEST',
  GetUnnamedRetentionMetricSuccess = 'retention/GET_UNNAMED_RETENTION_METRIC_SUCCESS',
  GetUnnamedRetentionMetricFailure = 'retention/GET_UNNAMED_RETENTION_METRIC_FAILURE',
  ComputeRetentionMetricRequest = 'retention/COMPUTE_RETENTION_METRIC_REQUEST',
  ComputeRetentionMetricSuccess = 'retention/COMPUTE_RETENTION_METRIC_SUCCESS',
  ComputeRetentionMetricFailure = 'retention/COMPUTE_RETENTION_METRIC_FAILURE',
  RetentionMetricsAccessRequest = 'retention/GET_ACCESS_REQUEST',
  RetentionMetricsAccessSuccess = 'retention/GET_ACCESS_SUCCESS',
  RetentionMetricsAccessFailure = 'retention/GET_ACCESS_FAILURE',
  RetentionMetricsAppCacheIsLoading = 'retention/APP_CACHE_IS_LOADING',
  RetentionMetricsAppCacheLoadFailed = 'retention/APP_CACHE_LOAD_FAILED',
  RetentionMetricsAppCacheRefetching = 'retention/APP_CACHE_IS_REFETCHING',
  RetentionMetricsAppCacheHasData = 'retention/APP_CACHE_HAS_DATA',
  RetentionMetricsAppCacheFresh = 'retention/APP_CACHE_FRESH',
  RetentionMetricsAppCacheSwap = 'retention/APP_CACHE_SWAP',
  RetentionMetricsAppCacheClear = 'retention/APP_CACHE_CLEAR',
}

export type RetentionMetricsById = { [id: string]: RetentionMetricDetail };
export type RetentionMetricsState = RetentionMetricsById;

export interface RetentionMetricsCacheData {
  status: AppCacheStatus;
  ready: boolean;
  data: ComputeRetentionMetricResponseWithId | null;
  storageId: string;
  safeMessage: string | null;
}

export type RetentionWithId = WithID<Retention>;

export interface RetentionResultWithId extends RetentionResult {
  retentions: RetentionWithId[];
}

export interface ComputeRetentionMetricResponseWithId extends ComputeRetentionMetricsResponse {
  retention: RetentionResultWithId | null;
}

export interface RetentionMetricsRequestBody
  extends Omit<ComputeRetentionMetricsRequest, 'now' | 'timezone' | 'cacheOptions'> {
  cacheOptions?: QueryCacheOptions;
}
